

import QRCode from 'react-qr-code';
import { Button } from '@/components/ui/button';
import { Download } from 'lucide-react';
import { useToast } from '@/hooks/use-toast';
import { downloadQRCode } from '@/utils/qrCodeDownload';

interface QRCodeTabProps {
  shareUrl: string;
}

export function QRCodeTab({ shareUrl }: QRCodeTabProps) {
  const { toast } = useToast();

  // Function to download QR code as PNG
  const downloadQRCodeHandler = async () => {
    if (!shareUrl) return;

    const svg = document.getElementById('qr-code');
    if (!svg) return;

    try {
      await downloadQRCode(svg as unknown as SVGElement, 'game-plan-qr-code', { size: 200 });

      toast({
        title: "QR code downloaded",
        description: "Your game plan QR code has been saved successfully.",
      });
    } catch (error) {
      console.error("Error downloading QR code:", error);
      toast({
        title: "Download failed",
        description: "Could not download the QR code. Please try again.",
        variant: "destructive"
      });
    }
  };
  
  return (
    <div className="flex flex-col items-center py-4 space-y-4">
      {shareUrl ? (
        <>
          <div className="p-4 bg-white rounded-md">
            <QRCode id="qr-code" value={shareUrl} size={180} />
          </div>
          <Button
            onClick={downloadQRCodeHandler}
            variant="outline"
            className="flex items-center gap-2"
          >
            <Download className="h-4 w-4" />
            Download QR Code
          </Button>
        </>
      ) : (
        <p className="text-muted-foreground py-10">Waiting for share link...</p>
      )}
    </div>
  );
}
